class FootingButtonComponent extends HTMLElement {

  constructor() {
    super();
    document.addEventListener('project-loaded', async (event) => this.onUpdate(event.detail), true)
    document.addEventListener('update-footing-conditions-button', async (event) => this.onUpdate(event.detail), true)
  }

  onUpdate(footingDesign) {
    let str = `<strong>Spread Footing</strong>`
    str += `<div>Soil Bearing (<em>q<sub>allowable</sub></em>) = ${footingDesign.footingConditions.soilBearing} psf</div>`
    str += `<div>Concrete Strength (<em>f'<sub>c</sub></em>) = ${footingDesign.footingConditions.concreteStrength} ksi</div>`
    str += `<div>Steel Yield Strength (<em>f<sub>y</sub></em>) = ${footingDesign.footingConditions.tensileStrength} ksi</div> `
    str += `<div>Concrete Density (<em>&gamma;<sub>c</sub></em>)= ${footingDesign.footingConditions.concreteDensity} lb/ft<sup>3</sup></div> `
    str += `<div>Reinforcement Bar Cover = ${footingDesign.footingConditions.cover} inches</div> `
    document.getElementById('footing-conditions-button').innerHTML = str
  }

  connectedCallback() {
    this.innerHTML = String.raw`
      <div class="card">
        <a href="#" data-bs-toggle="modal" data-bs-target="#modal-footing-conditions-dialog" style="text-decoration: none;">
          <div class="panel-shadow text-center" style="padding:10px;" id="footing-conditions-button">
          </div>
        </a>
      </div>
    `
  }
}

customElements.define('footing-button-component', FootingButtonComponent);